import { globalActions } from '../../global-actions';

export const actionTypes = {
  PARSELY_SET_CURRENT_CONSENT: 'PARSELY_SET_CURRENT_CONSENT',
  PARSELY_SET_CONSENT_OPTION_SELECTED: 'PARSELY_SET_CONSENT_OPTION_SELECTED',
  PARSELY_OPEN_MODAL_PRIVACY: 'PARSELY_OPEN_MODAL_PRIVACY',
  PARSELY_CLOSE_MODAL_PRIVACY: 'PARSELY_CLOSE_MODAL_PRIVACY',
};

export const actions = {
  setCurrentConsent: (consent) => {
    globalActions.next({
      type: actionTypes.PARSELY_SET_CURRENT_CONSENT,
      payload: { consent },
    });
  },
  setConsentOptionSelected: (consentOptionSelected, hideMessage) => {
    globalActions.next({
      type: actionTypes.PARSELY_SET_CONSENT_OPTION_SELECTED,
      payload: { consentOptionSelected, hideMessage },
    });
  },
  openModalPrivacy: (currentWidgetHtmlId) => {
    globalActions.next({
      type: actionTypes.PARSELY_OPEN_MODAL_PRIVACY,
      payload: {
        currentWidgetHtmlId,
      },
    });
  },
  closeModalPrivacy: () => {
    globalActions.next({
      type: actionTypes.PARSELY_CLOSE_MODAL_PRIVACY,
    });
  },
};
